import { apiProvider } from "@/services/utilities/Provider";

const getList = (page = 1, pageSize = 20) => apiProvider.get(`/Agent/all?page=${page}&pageSize=${pageSize}`);
const getById = (id) => apiProvider.get(`/Agent/${id}`);
const getByIdAdmin = (id) => apiProvider.get(`/Agent/${id}/admin`);
const create = (agent) => apiProvider.post('Agent', agent);
const assignScenario = (agentId, scenarioId) => apiProvider.put(`Agent/${agentId}/scenario/${scenarioId}`, {});

export default { getList, getById, getByIdAdmin, create, assignScenario };
